import styled, { css } from 'styled-components';

import { Link } from '@xing-com/link';
import {
  cornerRadiusXL,
  scale010,
  spaceS,
  xdlColorFocusRing,
  xdlColorHoverSecondary,
  xdlColorText,
} from '@xing-com/tokens';

export const StyledTitle = styled.p`
  margin: 0;
  text-decoration: none;
  text-align: left;
  white-space: nowrap;
`;

export const StyledLink = styled(Link)<{
  $isActive: boolean;
}>`
  color: ${xdlColorText};
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  border-radius: ${cornerRadiusXL};
  padding: ${spaceS};

  &:hover,
  &:active {
    text-decoration: none;
    background-color: ${xdlColorHoverSecondary};

    @media (prefers-contrast: more) {
      outline: ${scale010} solid ${xdlColorFocusRing};
    }
  }

  &:focus {
    text-decoration: none;
    outline: ${scale010} solid ${xdlColorFocusRing};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: bold;
    `};
`;
